import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const KeepOracleMarketTab = () => {
  return (
    <div
      className="tab-pane fade"
      id="keep-oraclemarket"
      role="tabpanel"
      aria-labelledby="keep-oraclemarket-tab"
    >
      <div className="keep-oraclemarket currency-conversion">
        <div className="create-account">
          <h4>Keep OracleMarket</h4>
          <p>
            Your OracleMarket account is free for personal use as long as you log in
            or make a transaction at least every 6 months.
          </p>
          <p>
            Otherwise a service fee of EUR 5.00 (or equivalent) will be deducted
            monthly from your account.
          </p>
          <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
            Open a free account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default KeepOracleMarketTab;
